import { Locale, type LocalizedString } from "../Locale.js";

export const voucherPathMap = {
	[Locale.cs]: "darkove-poukazy" as const,
} satisfies LocalizedString;
